import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { useQuery } from "bi-lib";

export default function useSetupStateCodeData() {
    const apis = useApis();
    const getSortedStateCodeQuery = useQuery({
        queryKey: [QueryKeys.GetSortedStateCode],
        queryFn: () => apis.engine.setupApi.setupApiGetSortedStateCodeList(),
    });

    return {
        stateCodes: getSortedStateCodeQuery,
    };
}
